<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="viewKey" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    viewKey() {
      const matched = Array.isArray(this.$route.matched) ? this.$route.matched : [];
      const lastMatchedRoute = matched[matched.length - 1];
      const name = lastMatchedRoute && lastMatchedRoute.name ? lastMatchedRoute.name : this.$route.path;
      // 关闭 / 刷新标签后，该页面需要拿到全新的容器实例（否则会复用旧的父子组件树），
      // 这里通过 cacheEpochs 让 key 发生变化：只失效当前页面，不影响同容器内其它页面。
      const epoch = this.$store.state.tagsView.cacheEpochs[name] || 0;
      return epoch ? `${name}#${epoch}` : name;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 85px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

